import { appStrings } from "./app";

export const permissionStrings = {
  global: { ...appStrings },
};
